// extracted by mini-css-extract-plugin
module.exports = {"loginBtn":"password-reset_loginBtn__yV_EL"};